export default "__VITE_ASSET__036d17e3__"